import {loadDetailContent} from "../detail";

export function switchToDetail(reload = true) {
	if (typeof gridSettings === 'undefined') {
		return;
	}

	let focusedCell = gridSettings.api.getFocusedCell();
	if (focusedCell === null || typeof focusedCell === 'undefined') {
		var selectedNodes = gridSettings.api.getSelectedNodes();
		if (selectedNodes && selectedNodes.length === 1) {
			var selectedNode = selectedNodes[0];
		}
	} else {
		var selectedNode = gridSettings.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
	}

	if (typeof selectedNode !== 'undefined') {
		selectedNode.setSelected(true, true)
		gridSettings.api.setFocusedCell(selectedNode.rowIndex, 'id');
	}

	if (reload) {
		showLoadingProgress()
		loadDetailContent(selectedNode.data.id)
	} else {
		$('[data-role="list"]').hide();
		$('[data-role="detail"]').show();
		$('#gridViewSwitcher').kendoButtonGroup().data('kendoButtonGroup').select(1);
	}
}

